/** @file validateDoc rule for IK dependency loops (§6.6): CYCLE naming the constraints, as commands do. */
import type { Doc } from './schema';
import { ikCycles } from './ikCycles';
import { makeError, type Pose2DError } from '../pose2dError';

/**
 * CYCLE for one ikCycles loop: a target below its own chain at `constraints.<id>.target`, a loop across constraints at
 * `constraints.<first>`. params.path spells the loop with constraint names (the convention editWithoutIkCycle shares).
 */
function cycleError(doc: Doc, loop: readonly string[]): Pose2DError {
  const first = loop[0] ?? '';
  const ring = [...loop, first].map((id) => doc.constraints[id]?.name ?? id).join(' -> ');
  if (loop.length === 1) {
    return makeError('CYCLE', { path: ring }, { path: `constraints.${first}.target`, hint: `IK constraint "${doc.constraints[first]?.name ?? first}": the target is inside the bones it moves` });
  }
  return makeError('CYCLE', { path: ring }, { path: `constraints.${first}`, hint: `each of these IK constraints moves a bone another one reads, so no update order exists: ${ring}` });
}

/** Appends CYCLE for every IK dependency loop of `doc` (a target below its own chain included). */
export function checkDocIkCycles(doc: Doc, out: Pose2DError[]): void {
  for (const loop of ikCycles(doc)) out.push(cycleError(doc, loop));
}
